import { RouterProvider } from "@tanstack/react-router";
import { Toaster } from "sonner";
import { router } from "./lib/router";

import "./styles.css";
import { useAuth } from "./lib/keycloak";
import { AppProviders } from "./app/app-providers.tsx";
import { useFeatures } from "./hooks/use-features/use-features.tsx";

// ------------------------------------------------------------

function InnerApp() {
	const auth = useAuth();
	useFeatures();

	return (
		<>
			<RouterProvider router={router} context={{ auth }} />
			<Toaster richColors />
		</>
	);
}

export function App() {
	return (
		<AppProviders>
			<InnerApp />
		</AppProviders>
	);
}
